import {
    Card,
    CardHeaderTheme,
    CardTheme,
    CardBorderRadius,
    CardBorderStyle,
    AddressLocation,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
    AddressLocationControlPadding,
    AddressLocationFontSize,
} from '@apply/components';
import { PropertiesTable } from './components/PropertiesTable/PropertiesTable';
import { GCUserProperty } from '@apply/api/src/api/ApplyApi';
import { addressBuilder } from './constants/addressBuilder';

export interface PortfolioPanelProps {
    properties: GCUserProperty[];
    onRefresh: () => void;
}

export const NonPortfolioPanel: React.FC<PortfolioPanelProps> = ({ properties, onRefresh }) => {
    const headerContentAddress = () => {
        return (
            <AddressLocation
                addressLine1={addressBuilder(properties[0])}
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    return (
        <>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Gray}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                <PropertiesTable
                    isPortfolio={false}
                    properties={properties}
                    onRefresh={onRefresh}
                />
            </Card>
        </>
    );
};
